import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import {
  StoriesTeaserAndCTAContainer,
  StoriesTeaser,
  StoriesCTA,
  ButtonContainer,
} from "./style"

const StoriesTeaserAndCTA = ({
  title,
  tag,
  excerpt,
  label,
  link,
  buttonLabel,
}) => {
  const data = useStaticQuery(
    graphql`
      query {
        twoLinksImage: file(relativePath: { eq: "twolinksimage.png" }) {
          childImageSharp {
            fluid(maxWidth: 2560, quality: 100) {
              ...GatsbyImageSharpFluid_withWebp_noBase64
            }
          }
        }
      }
    `
  )
  console.log("data:", data)

  return (
    <StoriesTeaserAndCTAContainer>
      <StoriesTeaser
        title={title}
        tag={tag}
        excerpt={excerpt}
        label={label}
        link={link}
        img={data.twoLinksImage.childImageSharp.fluid}
      ></StoriesTeaser>
      <ButtonContainer>
        <StoriesCTA label={buttonLabel} link={"/"} />
      </ButtonContainer>
      {/* <DividerLines /> */}
    </StoriesTeaserAndCTAContainer>
  )
}

export default StoriesTeaserAndCTA

StoriesTeaserAndCTA.defaultProps = {
  title: "Courtney Moore: Moved to Canberra from South Africa",
  tag: "cbr stories",
  excerpt:
    "Falling in love brought Courtney Moore to Canberra for the first time in 2009. The year before she had met Stephen Moore, a Brumbies and Wallaby player, at an after-match function in South Africa, and romance blossomed.",
  label: "Read more",
  buttonLabel: "View all stories",
  link: "/",
}
